import { render, staticRenderFns } from "./DashboardDialog.vue?vue&type=template&id=4c514fca&"
import script from "./DashboardDialog.vue?vue&type=script&lang=ts&"
export * from "./DashboardDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports